/**
 * テーブル行コンポーネント
 * @packageDocumentation
 * @module components/TableRow
 * @category Component
 * @subcategory TableRow
 */

/**
 * テーブル行のプロパティ
 */
export interface TableRowProps {
  label: string;
  value: string;
}

/**
 * テーブル行コンポーネント
 * @param {TableRowProps} props - テーブル行のプロパティ
 * @returns {JSX.Element} テーブル行のJSX要素
 */
export const TableRow: React.FC<TableRowProps> = ({ label, value }) => (
  <tr className="c-table__row">
    <th className="c-table__cell c-table__cell--w15">{label}</th>
    <td className="c-table__cell">{value}</td>
  </tr>
);
